import { DecimalPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { JackpotBet } from '@features/jackpot/interfaces/jackpot.interface';
import { PlayerRowComponent } from '../../../core/components/player-row/player-row.component';
import { CostComponent } from '../../../core/components/cost/cost.component';
import { ContextMenuService } from '@core/services/context-menu.service';

@Component({
  selector: 'app-jackpot-user-bet',
  templateUrl: './jackpot-user-bet.component.html',
  styleUrls: ['./jackpot-user-bet.component.scss'],
  standalone: true,
  imports: [DecimalPipe, PlayerRowComponent, CostComponent],
})
export class JackpotUserBetComponent {
  readonly bet = input.required<JackpotBet>();
  readonly isEnd = input.required<boolean>();
  readonly isWinner = input.required<boolean>();

  contextMenuService = inject(ContextMenuService);
}
